import React, { Component } from 'react'
import MybetsTable from 'components/mybets/MybetsTable'
import { getStatus } from 'utils/converters'
import { calculateBetReturn } from 'utils/calculations'
import { connect } from 'react-redux'
import { firebaseRef } from 'config'
import 'css/mybets.less'
import ChangeBetModal from 'components/mybets/ChangeBetModal'
import AddCustomBetModal from 'components/mybets/AddCustomBetModal'

class MybetsContainer extends Component {
  constructor(props) {
    super(props)
    this.currencyRef = firebaseRef.child('currencies')
    this.filterBets = this.filterBets.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.sortBets = this.sortBets.bind(this)
    this.handleSortedColumn = this.handleSortedColumn.bind(this)
    this.getSortedProp = this.getSortedProp.bind(this)
    this.numDisplayed = 50
    this.state = {
      query: '',
      selectedBet: null,
      page: 0,
      sortedColumn: 'startTime',
      sortedDescending: true,
      showCustomBetModal: false
    }
  }

  componentDidMount() {
    window.analytics.page('My bets')
  }

  closeModal() {
    this.setState({
      selectedBet: null
    })
  }

  openModal(betId) {
    this.setState({
      selectedBet: this.props.userbets.find(bet => bet.id === betId)
    })
  }

  getSortedProp(bet) {
    if (this.state.sortedColumn === 'startTime')
      return bet.match.startTime
    if (this.state.sortedColumn === 'bookmaker')
      return bet.bookmaker.name
    if (this.state.sortedColumn === 'betReturn')
      return calculateBetReturn(bet.wager, bet.odds, bet.status)
    return bet[this.state.sortedColumn]
  }

  handleSortedColumn(column) {
    let changes = {}
    if (this.state.sortedColumn === column) {
      changes.sortedDescending = !this.state.sortedDescending
    } else {
      changes.sortedColumn = column
      changes.sortedDescending = true
    }
    if (Object.keys(changes).length > 0)
      this.setState(changes)
  }

  sortBets(bets) {
    let multiplier = this.state.sortedDescending ? 1 : -1
    return bets.slice().sort((a, b) => {
      let sorted = (this.getSortedProp(b) - this.getSortedProp(a)) * multiplier
      if (sorted === 0)
        return a.id - b.id
      return sorted
    })
  }

  filterBets(bets) {
    let { query } = this.state
    query = query.trim()
    let matcher = new RegExp(query, 'i')
    return bets.filter(bet => {
      return (
        matcher.test(bet.match.homeTeam) ||
        matcher.test(bet.match.awayTeam) ||
        (bet.match.competition ? matcher.test(bet.match.competition.name) : false) ||
        matcher.test(bet.bookmaker.name) ||
        matcher.test(getStatus[bet.status].text)
      )
    })
  }

  onQueryChange(query) {
    this.setState({
      query: query.target.value,
      page: 0
    })
  }

  changePage(page, e) {
    e.preventDefault()
    this.setState({page})
  }

  onCloseCustomBetModal() {
    this.setState({
      showCustomBetModal: false
    })
  }

  onShowCustomBetModal(e) {
    window.analytics.track('Click add custom bet')
    e.preventDefault()
    this.setState({
      showCustomBetModal: true
    })
  }

  render() {
    let userbets = [... this.props.userbets]
    if (this.state.query.length > 1) {
      userbets = this.filterBets(userbets)
    }
    userbets = this.sortBets(userbets)
    let paginationNumbers = []
    for (let i = Math.max(0, this.state.page - 3); i <= Math.min(userbets.length / this.numDisplayed, this.state.page + 3); i++)
      paginationNumbers.push(i)
    userbets = userbets.slice(this.numDisplayed * this.state.page, this.numDisplayed * (this.state.page + 1))
    return (
      <div className='container-fluid mybets-container'>
        <div className='panel'>
          <div className='panel-body'>
            <div className='clearfix'>
              <h4 id='title' className='col-xs-4'>MY BETS</h4>
              <div className='col-xs-8 form-inline form-group'>
                <button id='custom-bet' className='btn btn-primary pull-right'
                  onClick={this.onShowCustomBetModal.bind(this)} >
                  Add custom bet
                </button>
                <div className='input-group pull-right'>
                  <span className='input-group-addon'><i className='fa fa-search'></i></span>
                  <input type='text'
                    className='form-control'
                    placeholder='Search'
                    value={this.state.query}
                    onChange={this.onQueryChange.bind(this)}
                  />
                </div>
              </div>
            </div>
            <MybetsTable userbets={userbets}
              onClickRow={this.openModal}
              handleClickHeader={this.handleSortedColumn}
              sortedColumn={this.state.sortedColumn}
              sortedDescending={this.state.sortedDescending}
              />
            <div className='text-center'>
            { paginationNumbers.length > 1 && (
                <ul className='pagination'>
                  { paginationNumbers.map(num => {
                    let className = ''
                    if (num === this.state.page)
                      className = 'active'
                    return (
                      <li key={num} className={className}>
                        <a href="#" onClick={this.changePage.bind(this, num)}>{ num + 1}</a>
                      </li>
                    )
                  })}
                </ul>
              )
            }
            </div>
          </div>
        </div>
        <ChangeBetModal bet={ this.state.selectedBet } closeModal={this.closeModal} />
        <AddCustomBetModal show={this.state.showCustomBetModal}
          onCloseCustomBetModal={this.onCloseCustomBetModal.bind(this)}
          user={this.props.user}
          currencies={this.props.currencies}
        />
      </div>
    )
  }
}

export default connect(state => {
  return {
    userbets: state.userbets,
    currencies: state.currencies
  }})(MybetsContainer)



/** WEBPACK FOOTER **
 ** ./src/containers/MybetsContainer.js
 **/